import { writable } from 'svelte/store';

let siteText            = 'Serra & Lar';
let siteDescription     = 'Administração de Condomínios, Aluguel, Compra e Venda de Imóveis';

export let tagsSEO      = writable('Administração de Condomínios, <br class="hidden-sm hidden-xs"/>Aluguel e Venda de Imóveis<br class="hidden-sm hidden-xs"/> na Serra Gaúcha.');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

export const ntRent			= writable('1');
export const ntSeason		= writable('2');
export const ntSell			= writable('0');

// E-mails
export const mailAtendimento	= writable("siteatendimento@serraelar.com.br");
export const mailLocacao		= writable("sitelocacao@serraelar.com.br");
export const mailVendas			= writable("sitevendas@serraelar.com.br");
export const mailOuvidoria		= writable("siteatendimento@serraelar.com.br");
export const mailRH				= writable("siteatendimento@serraelar.com.br");
export const mailLista			= writable("sitelista@serraelar.com.br");
export const mailAtualize		= writable("siteatendimento@serraelar.com.br");
export const mailCadastro		= writable("siteatendimento@serraelar.com.br");
export const mailCondominios	= writable("siteatendimento@serraelar.com.br");
export const mailProposta		= writable("siteatendimento@serraelar.com.br");

export const textTelefoneVendas		= writable("(54) 99177-4368");
export const linkTelefoneVendas		= writable("https://wa.me/5554991774368");

export const textTelefoneLocacao	= writable("(54) 99937-6430");
export const linkTelefoneLocacao	= writable("https://wa.me/5554999376430");

export const textTelefoneCondominio	= writable("(54) 99909-0164");
export const linkTelefoneCondominio	= writable("https://wa.me/5554999090164");

export const whatsappVendas			= writable("5554991774368");
export const textWhatsappVendas		= writable("(54) 99177-4368");
export const linkWhatsappVendas		= writable("https://wa.me/5554991774368");

export const whatsappLocacao		= writable("5554999376430");
export const textWhatsappLocacao	= writable("(54) 99937-6430");
export const linkWhatsappLocacao	= writable("https://wa.me/5554999376430");

export const whatsappCondominio		= writable("5554999090164");
export const textWhatsappCondominio	= writable("(54) 99909-0164");
export const linkWhatsappCondominio	= writable("https://wa.me/5554999090164");

export const whatsappCondominio2		= writable("5554984386731");
export const textWhatsappCondominio2	= writable("(54) 98438-6731");
export const linkWhatsappCondominio2	= writable("https://wa.me/5554984386731");

export const whatsappPlantao		= writable("5554999747324");
export const textWhatsappPlantao	= writable("(54) 99974-7324");
export const linkWhatsappPlantao	= writable("https://wa.me/5554999747324");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#tipo_negociacao=2");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#tipo_negociacao=1");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/profile.php?id=100087115488782");
export const linkInstagram      = writable("https://www.instagram.com/serraelar/");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("");
export const linkBlog	        = writable("");

export const linkAPI            = writable("http://www.api.com.br");
export const linkAV             = writable("https://serraelar.com.br/serraelar/dashboard");
export const linkAreaCliente	= writable("/area-cliente");
export const linkConheca        = writable("https://serraelar.com.br/siteav/");
export const linkSolicite       = writable("https://serraelar.com.br/serraelar/login?help=1");
export const linkBoletoFacil    = writable("https://serraelar.com.br/serraelar/login?boleto-facil=1");

export const textAtendimento    = writable("De Segunda-Feira à Sexta-Feira, das 08h às 12h e das 13h15 à 18h.");
export const textEndereco       = writable("Rua Gabriel de Moraes Velho, 67, Palace Hotel, Canela, RS");
export const textCNPJ           = writable("07406646000112");
export const textCreci          = writable("J22388");

export const linkMapa           = writable("https://maps.app.goo.gl/CwzUwb6sgMqevXv16");
export const linkWaze           = writable("https://ul.waze.com/ul?place=ChIJ98fNlbAtGZURDVPhCTcrcOM&ll=-29.36292200%2C-50.80258530&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=fXeQi8rFXKDdCQa8OUdszLLtjeW2JKn7&pickup=my_location&dropoff[formatted_address]=Serra%20%26%20Lar%20Im%C3%B3veis%20%7C%20Venda%20Loca%C3%A7%C3%A3o%20%26%20Administra%C3%A7%C3%A3o%20de%20condom%C3%ADnios%20-%20Avenida%20Palace%20Hotel%20-%20Eug%C3%AAnio%20Ferreira%2C%20Canela%20-%20RS%2C%20Brasil&dropoff[latitude]=-29.362922&dropoff[longitude]=-50.802585");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1043.793524423569!2d-50.80245465144509!3d-29.362925498510236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95192db095cdc7f7%3A0xe3702b3709e1530d!2zU2VycmEgJiBMYXIgSW3Ds3ZlaXMgfCBWZW5kYSBMb2Nhw6fDo28gJiBBZG1pbmlzdHJhw6fDo28gZGUgY29uZG9tw61uaW9z!5e0!3m2!1spt-BR!2sbr!4v1703081958206!5m2!1spt-BR!2sbr");

export const linkPoliticaPrivacidade	= writable("/assets/files/PoliticaDePrivacidade.pdf");
export const linkPoliticaCookies		= writable("/assets/files/PoliticaDePrivacidade.pdf");

export const textPoliticaCheck 			= writable("Aceito compartilhar meus dados de acordo com a <a href='/assets/files/PoliticaDePrivacidade.pdf' target='_blank'>Política de Privacidade</a> da Serra e Lar. Estou ciente e concordo em receber todas as comunicações relativas ao meu cadastro, incluindo comunicados, informações e promoções.");

export const todosContatos = writable([
	{
		title: 'Atendimento Geral',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/555432781001',
		target: '_blank',
		phone: '(54) 3278-1001',
		email: 'siteatendimento@serraelar.com.br'
	},
	{
		title: 'Vendas',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/5554991774368',
		target: '_blank',
		phone: '(54) 99177-4368',
		email: 'siteatendimento@serraelar.com.br'
	},
	{
		title: 'Plantão (SOMENTE URGÊNCIAS) após 18h, sábados, domingos e feriados',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/5554999747324',
		target: '_blank',
		phone: '(54) 99974-7324',
		email: 'siteatendimento@serraelar.com.br'
	},
]);

export const propostaContatos = writable([
	{
		title: 'Atendimento Geral',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/555432781001',
		target: '_blank',
		phone: '(54) 3278-1001',
		email: 'siteatendimento@serraelar.com.br'
	},
	{
		title: 'Vendas',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/5554991774368',
		target: '_blank',
		phone: '(54) 99177-4368',
		email: 'siteatendimento@serraelar.com.br'
	},
	{
		title: 'Plantão (SOMENTE URGÊNCIAS) após 18h, sábados, domingos e feriados',
		icon: '<i class="fab fa-whatsapp fa-fw"></i>',
		href: 'https://wa.me/5554999747324',
		target: '_blank',
		phone: '(54) 99974-7324',
		email: 'siteatendimento@serraelar.com.br'
	},
]);

export const comoChegar = writable([
	{
		title: 'Mapa',
		icon: '<i class="fas fa-map-marked-alt color-accent"></i>',
		link: 'https://goo.gl/maps/XRft6zZq9BZQKiau8',
	},
	{
		title: 'Waze',
		icon: '<i class="fab fa-waze color-accent"></i>',
		link: 'https://www.waze.com/pt-BR/livemap/directions/brasil/rio-grande-do-sul/serra-and-lar-imoveis-ltda?navigate=yes&place=ChIJ98fNlbAtGZURDVPhCTcrcOM',
	},
	{
		title: 'Uber',
		icon: '<i class="fab fa-uber color-accent"></i>',
		link: 'https://m.uber.com/ul/?action=setPickup&client_id=%20Rua%20Augusto%20Pestana%2C%20171%2C%20Centro%2C%20Canela%2C%20RS&pickup=my_location&dropoff[formatted_address]=Rua%20Augusto%20Pestana%2C%20171%20-%20Centro%2C%20Canela%20-%20RS%2C%20Brasil&dropoff[latitude]=-29.361532&dropoff[longitude]=-50.813573',
	}
]);